import type { MapContext } from "../map/types";
import { composeAttrsForClickTracking, MAP_MODULE_ID, PAGE_ID } from "../../utils/tracking";

<context|ctx| from="map">
  $ const { watchInstance: watchInstanceCtx, localizedContent: localizedContentCtx } = (ctx || {}) as MapContext;
  $ const { watchInstance: watchinstanceInput, localizedContent: localizedContentInput } = input;
  $ const watchDataProvider = watchinstanceInput || watchInstanceCtx;
  $ const localizedContent = localizedContentInput || localizedContentCtx;
  $ const trackingData = {
    pageId: PAGE_ID,
    moduleId: MAP_MODULE_ID,
    eventAction: "CLICK",
    eventFamily: "MAPVIEW",
    linkId: "180878",
  };

  <if(watchDataProvider && localizedContent)>
    <div data-testid="item-watchlist" class="item-watchlist">
      <watch-heart-cta
        a11yText=component.getAccessibilityLabel()
        watchDataProvider=watchDataProvider
        itemDetails=state.itemDetails
        localizedContent=localizedContent
        trackingData={
          ...trackingData,
          ...composeAttrsForClickTracking(trackingData.linkId, "watchlist_item", trackingData.pageId),
        }
        on-watchUpdateHandler("handleWatchUpdate")
        on-watchAction("handleToggleWatchAction")
        on-unwatchAction("handleToggleWatchAction")
      />
    </div>
  </if>
</context>
